export const en = {
    'desktop-view': 'todo',
    'mobile-view': 'todo',
    'new-tab-view': 'todo'
};
